/**
 * @fileOverview URL操作に関するユーティリティ群を提供する
 */

export const URL_PARAM_CP_ID = "cid";
export const URL_PARAM_SERIAL_CODE = "scd";
export const URL_PARAM_TOKEN = "token";
export const URL_PARAM_ERROR = "error";
export const URL_PARAM_REDIRECT_CODE = "rd_cd";
export const URL_PARAM_TYPE = "type";
export const URL_PARAM_USED = "used";
export const URL_PARAM_URL = "url";
export const URL_PARAM_STATE = "state";
export const URL_PARAM_COURSE = "course";
export const URL_PARAM_TRAN_SRC = "tran_src";

/**
 * キーに対応するクエリパラメータの取得
 * @param {String} key
 * @return {string}
 */
export const getQueryParamValue = (key: string): string => {
  const url = window.location.search.replace("?", "");
  const keyIndex = url.indexOf(key);

  if (keyIndex === -1) return "";

  const startCharIndex = url.indexOf("=", keyIndex) + 1;
  const endCharIndex = url.indexOf("&", keyIndex);

  return endCharIndex !== -1
    ? url.substr(startCharIndex, endCharIndex - startCharIndex)
    : url.substr(startCharIndex);
};

export const copyToClipboard = (text: string): void => {
  if (navigator.clipboard) {
    const copyText = text;
    navigator.clipboard.writeText(copyText).then(function () {
      alert("コピーしました。");
    });
  } else {
    alert("対応していません。");
  }
};
